module.exports = __webpack_public_path__ + "img/Banner-image-AOV-Mobile.d535b64c.jpg";